package br.com.vvrefeicoes.portal.domain.model

data class AuditEntry(
    val id: String,
    val occurredAt: String,
    val code: String,
    val userName: String,
    val module: String,
    val description: String,
    val result: AuditResult,
    val actorProfile: String? = null,
    val resourceId: String? = null,
    val httpStatus: Int? = null,
    val details: String = "",
)
